<meta name="viewport" content="width=device-width, initial-scale=1.0" />


<div class="container-flex" *ngIf="data[0].id==1 || data[0].id==2; else fdesk">
  <div class="row  ml-2">
    <div class="col-sm">
      <div class="card dash-message shade">
        <div class="h-150  dash-message">

          <h5 class="pt-3 pl-3 header-title heading-color">
            Hello Dr {{phyfname?phyfname:''}} {{phylname?phylname:''}}
          </h5><br />


          <div class="row text-center ">

            <div class="col">

              <span class="custom-control custom-switch d-inline-block">
                <input type="checkbox" class="custom-control-input" id="enable" [checked]="consultChecked"
                  (change)="checkValue((consultChecked = !consultChecked))" />
                <label class="custom-control-label" for="enable"></label>
              </span>


              <div class=""><b>Make me Online</b></div>
              <br />
              <div class="row text-center">
                <a style="cursor: pointer;" routerLink="/doctor-calendar">
                  <i class="fas fa-calendar-alt " style="font-size: 32px;"></i></a>
              </div>
              <br />

              <!-- <div class="row text-center">
                <a id="shoPat" routerLink="/appointment/consultation">
                  <h6>Attend my Patients</h6>
                </a>
              </div>-->
              <br />
            </div>

            <div class="col-1 d-none d-md-block">
              <div class="vl"></div>
            </div>
            <br />

            <div class="col sm-1">

              <div class="row">
                <!-- <a style="cursor: pointer;" routerLink="/doctor-calendar">
                  <i class="fas fa-calendar-alt " style="font-size: 64px;"></i></a> -->
                <a href="#" [routerLink]="['/profile/physicians-profile/'+uid]" data-bs-toggle="tooltip"
                  data-bs-placement="bottom" title={{this.msg}}>
                  <circle-progress class="circle__progress" [percent]=weightage [animation]="true"
                    [animationDuration]="800" [startFromZero]="true" [showInnerStroke]="true" [titleFontSize]="'28'"
                    [titleFontWeight]="'500'" [unitsFontSize]="'28'" [unitsFontWeight]="'300'"
                    [subtitle]="'Profile Completetion'" [subtitleFontSize]="'8'" [lazy]="false"
                    [backgroundColor]="'white'" [radius]="'50'" [maxPercent]="'100'" [unitsColor]="'#483500'"
                    [outerStrokeWidth]="'5'" [outerStrokeColor]=color [innerStrokeColor]="'black'"
                    [titleColor]="'#483500'" [subtitleColor]="'#483500'" [showSubtitle]=false [showInnerStroke]=false
                    [startFromZero]=false></circle-progress>

                </a>
                <!-- <div calss="progress" ng-controller="AppCtrl as vm" ng-cloak="" ng-app="MyApp" layout-fill layout="row"
                  layout-align="center center">
                  <div style="width:100px; height:100px">
                    <md-progress-circular md-diameter="100" md-mode="determinate" value="60">
                    </md-progress-circular>
                    <a href="#" data-bs-toggle="tooltip" data-bs-placement="bottom" title={{this.msg}}>
                      <h4 id="progress">{{this.weightage}}%</h4>
                    </a>

                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-8 ">
      <div class=" card dash-message  shade">
        <div class="dash-message ">


          <h5 class="pt-3 pl-3 header-title heading-color">
            Today's Appointments
          </h5>


          <div class="row  pl-3 pr-3 text-center " *ngFor="let bam of rcounts">

            <div class="col">
              <div class="card shade">
                <i class="pt-2    fa fa-globe" style="color:royalblue; font-size: 24px;"></i>
                <div class="card-body">
                  <h5 class="card-title"><b>
                      {{dashboardvalues1?.online_physician_request_count?dashboardvalues1.online_physician_request_count:'0'}}
                      /
                      {{dashboardvalues1?.online_physician_schedule_count?dashboardvalues1.online_physician_schedule_count:'0'}}
                    </b></h5>
                  <p class="card-text"><b>Request / Schedule</b></p>
                </div>
                <p class="card-text "><strong> Online</strong></p>
              </div>
            </div>

            <div class="col">
              <div class="card shade ">
                <i class="pt-2 	fas fa-person-booth" style="color:royalblue;  font-size: 24px;"></i>
                <div class="card-body">
                  <h5 class="card-title"><b>
                      {{dashboardvalues1?.inperson_physician_schedule_count?dashboardvalues1.inperson_physician_schedule_count:'0'}}
                      /
                      {{dashboardvalues1?.inperson_physician_checkin_count?dashboardvalues1.inperson_physician_checkin_count:'0'}}
                    </b></h5>
                  <p class="card-text"><b> Schedule / Checkin</b></p>
                </div>
                <p class="card-text "><strong> In-person</strong></p>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>

  </div>

  <div class="row ml-2">

    <div class="col-sm">

      <div class="col card dash-message mt-2  shade ">
        <div class="dash-message mt-2 mb-2">


          <div class="header-title heading-color">
            Pending Appointments
          </div>

          <div class="row">

            <div class="col-2 pt-2 align-items-right ">
              <i class=" fa fa-clock icosize" aria-hidden="true"></i>
            </div>
            <div class="col-10  pl-5">

              <p class="card-text ">
                <b>Online&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>
                <b>&nbsp;{{todaysOnlineAppointmentallCount?todaysOnlineAppointmentallCount:0}}</b>&nbsp;
                <a id="shoPat" routerLink="/appointment/consultation" class="">
                  <i class="fa fa-eye"></i>
                </a>
              </p>

              <p class="card-text">
                <b> In-person :</b>
                <b>&nbsp;{{todaysInpersonAppointmentallCount}}</b>&nbsp;
                <a id="shoPat" routerLink="/appointments/Checkin" class=""><i class="fa fa-eye"></i> </a>
              </p>

            </div>
          </div>

        </div>
      </div>

      <div class="col card dash-message mt-2  shade">
        <div class="dash-message mt-2 mb-2">


          <div class="header-title heading-color">
            Completed Appointments
            <a id="shoPat" routerLink="/appointments/past" class="ml-3">

              <i class="fa fa-eye" aria-hidden="true"></i>
            </a>
          </div>

          <div class="row">


            <div class="col-2">
              <i class="fa fa-check icosize" aria-hidden="true"></i>
            </div>

            <div class="col-10  pl-5" *ngIf="dashboarddata">

              <p class="card-text ">
                <b>Online&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>
                <b>&nbsp;{{dashboarddata?.COMPLETED_APPOINTMENT_ONLINE.length}}</b>
              </p>

              <p class="card-text">
                <b> Inperson :</b>
                <b>&nbsp;{{dashboarddata?.COMPLETED_APPOINTMENT_INPERSON.length}}</b>
              </p>
            </div>

          </div>
        </div>
      </div>

      <div class="col card dash-message mt-2  shade">
        <div class="dash-message mt-2 mb-2">

          <div class="header-title heading-color">
            Appointment Status
          </div>

          <div class="row">


            <div class="col-2 ">
              <i class="fa fa-bar-chart icosize" aria-hidden="true"></i>
            </div>

            <div class="col-10  pl-5" *ngIf="dashboarddata">

              <p class="card-text">
                <b>Follow up :</b>
                <b>&nbsp;{{dashboarddata?.ONLINE_FOLLOWUP_APPOINTMENT.length}}</b>
              </p>

              <p class="card-text">
                <b>Cancelled :</b>
                <b>&nbsp;{{dashboarddata?.CANCEL_APPOINTMENT_ONLINE.length}}</b>
              </p>
            </div>

          </div>
        </div>
      </div>

      <div class="col card dash-message mt-2 mb-2  shade">
        <div class="dash-message mt-2 mb-2">


          <div class="header-title heading-color">
            Patients Count
          </div>

          <div class="row">


            <div class="col-2 ">
              <i class="fa fa-calculator icosize"></i>
            </div>

            <div class="col-10 pl-5" *ngIf="dashboarddata">

              <p class="card-text ">
                <b>Online&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</b>
                <b>&nbsp;{{dashboarddata?.PATIENT_ONLINE.length}}</b>
              </p>

              <p class="card-text">
                <b> Inperson :</b>
                <b>&nbsp;{{dashboarddata?.PATIENT_INPERSON.length}}</b>
              </p>
            </div>

          </div>

        </div>
      </div>

    </div>


    <div class="col-sm-8  d-none d-md-block">
      <div class="col mt-2" style="height: 440px; overflow: auto;">
        <app-aptreq-dash></app-aptreq-dash>
      </div>
    </div>

  </div>

  <div class="row pt-2 ml-2">

    <div class="col-sm-4 d-none d-md-block" style="padding-left: 0;">
      <div class="col" style="height: 400px; overflow: auto;">
        <table class="table mb-0 bg-white">
          <thead class="bg-light">
            <tr>
              <td>
                <div class="header-title heading-color">PATIENT LIST </div>
              </td>
              <!-- <td style="color: #2e60f2; letter-spacing: 0.02em; font-size: 15px;font-weight: 700;">PATIENT LIST </td> -->
            </tr>
            <tr>
              <td>
                <form [formGroup]="form">
                  <div class="input-group">
                    <input class="form-control border-end-0 border rounded-pill" type="search" formControlName="name"
                      placeholder="search by Patient name" id="example-search-input">
                    <span class="input-group-append">
                      <button class="btn btn-outline-secondary bg-white border-bottom-0 border rounded-pill ms-n5"
                        style="color:rgb(24, 21, 190)" type="submit" (click)="search()">
                        <i class="fa fa-search"></i>
                      </button>
                    </span>
                  </div>
                </form>
              </td>
            </tr>
          </thead>
          <div *ngIf="pat_users.length >0; else noRecord"></div>
          <tbody *ngFor="let fd of pat_users" align="center">
            <tr>
              <td>

                <div class="ms-3">
                  <p class="fw-bold mb-1">{{fd?.first_name}}&nbsp;{{fd?.last_name}}</p>
                  <p class="mb-1">{{fd?.contact_no}}</p>
                  <p class="mb-0">{{fd?.email_id}}</p>
                </div>

              </td>

            </tr>
          </tbody>

        </table>


      </div>
    </div>

    <div class="col-sm-8 d-none d-md-block">
      <div class="col" style="height: 400px; overflow: auto;">

        <app-checkin-dash></app-checkin-dash>

      </div>
    </div>

  </div>

</div>

<ng-template #fdesk>

  <div class="alert alert-info" role="alert">
    Welcome {{name1}} {{name2}}
  </div>

  <div class="row pb-3">
    <div class="col-sm-4">
      <div class="col card mr-3  shade">
        <div class="h-100  dash-message ">
          <div class="alert bg-primary fw-bold text-white  pt-2 heading-color">
            TODAY'S APPOINTMENTS
          </div>
          <div class="row text-center ">

            <div class="col">
              <div class="card shade">
                <i class="pt-2 fa fa-globe" style="color:royalblue; font-size: 24px;"></i>
                <div class="card-body">
                  <h5 class="card-title">
                    <b>{{a_dashboardvalues?.online_admin_request_count?a_dashboardvalues.online_admin_request_count:'0'}}
                      /
                      {{a_dashboardvalues?.online_admin_schedule_count?a_dashboardvalues.online_admin_schedule_count:'0'}}
                    </b>
                  </h5>
                  <p class="card-text"><b> Request / Schedule</b></p>
                </div>
                <p class="card-text "><strong> Online</strong></p>
              </div>
            </div>

            <div class="col">
              <div class="card shade">
                <i class="pt-2 	fas fa-person-booth" style="color:royalblue;  font-size: 24px;"></i>
                <div class="card-body">
                  <h5 class="card-title" *ngFor="let bam of rcounts"><b>
                      {{a_dashboardvalues?.inperson_admin_schedule_count?a_dashboardvalues.inperson_admin_schedule_count:'0'}}
                      /
                      {{a_dashboardvalues?.inperson_admin_checkin_count?a_dashboardvalues.inperson_admin_checkin_count:'0'}}</b>
                  </h5>
                  <p class="card-text"><b>Schedule / Checkin</b></p>
                </div>
                <p class="card-text "><strong> In-person</strong></p>
              </div>
            </div>


          </div>

          <br /><br />

        </div>
      </div>



      <div align="center" class="pt-4">
        <a style="cursor: pointer;" routerLink="/appointments/schedule">
          <button type="button" class="btn btn-lg btn-primary active">
            <span class="fa fa-stethoscope"></span>&nbsp;&nbsp;Create New Appointment
          </button>
        </a>
      </div>

    </div>

    <div class="col-sm-8  d-none d-md-block">
      <div class="col" style="height: 400px; overflow: auto;">
        <app-checkin-dash></app-checkin-dash>
      </div>
    </div>

  </div>



  <div class="row">

    <div class="col-sm-4 md-4">
      <app-profiles-dash></app-profiles-dash>
    </div>

    <div class="col-sm-8  d-none d-md-block">
      <div class="col" style="height: 400px; overflow: auto;">
        <app-checkout-dash></app-checkout-dash>
      </div>
    </div>

  </div>



</ng-template>